module.exports = __webpack_public_path__ + "img/jingzhuang9.da4d9711.jpg";